import Types from '../types';

// eslint-disable-next-line import/prefer-default-export
export const setAllCategoryServices = payload => ({
  type: Types.SET_ALL_CATEGORY_SERVICES,
  payload,
});
